// extracted by css-extract-rspack-plugin
export default {"root_reset":"root_reset-zx_jwt","rootReset":"root_reset-zx_jwt"};